// Sempre usa o proxy /api do próprio frontend, que encaminha ao Garm.
// Não aceita host externo nem segue redirecionamentos para outros serviços.
export async function loadRuntimeConfig() {
    const environment = process.env.REACT_APP_CONFIG_ENVIRONMENT || 'local';
    const url = `/api/mimir/public/services/controla-festas/runtime-config?environment=${encodeURIComponent(environment)}`;
    for (let tentativa = 0; tentativa < 3; tentativa += 1) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
            const response = await fetch(url, {
                signal: controller.signal,
                redirect: 'error',
                cache: 'no-store',
                credentials: 'same-origin',
            });
            if (!response.ok) throw new Error(`Falha ao carregar configuração pelo Garm: HTTP ${response.status}`);
            const payload = await response.json();
            if (!payload.variables || typeof payload.variables !== 'object' || Array.isArray(payload.variables)) {
                throw new Error('Configuração inválida recebida pelo Garm.');
            }
            window.__APP_CONFIG__ = payload.variables;
            return;
        } catch (error) {
            if (tentativa === 2) throw error;
        } finally {
            clearTimeout(timeout);
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
    }
}
